"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dayjs_1 = __importDefault(require("dayjs"));
const relativeTime_1 = __importDefault(require("dayjs/plugin/relativeTime"));
const quarterOfYear_1 = __importDefault(require("dayjs/plugin/quarterOfYear"));
const extended = (option, dayjsClass, dayjsFactory) => {
    dayjsClass.prototype.toSQL = function (hour = true) {
        if (!this.isValid())
            return '';
        return this.format('YYYY-MM-DD') + (hour ? ' ' + this.format('HH:mm:ss') : '');
    };
    dayjsClass.prototype.toStringDate = function (variant = 'short', hour) {
        if (!this.isValid())
            return '';
        if (variant === 'short') {
            return this.format('DD-MM-YYYY') + (hour ? ' ' + this.format('HH:mm') : '');
        }
        else if (variant === 'complete-short-month') {
            return this.format('DD-MMM-YY') + (hour ? ' ' + this.format('HH:mm') : '');
        }
        else if (variant === 'complete') {
            return this.format('D [de] MMMM [de] YYYY') + (hour ? ' ' + this.format('HH:mm') : '');
        }
        else if (variant === 'complete-with-day') {
            return this.format('dddd, D [de] MMMM [de] YYYY') + (hour ? ' ' + this.format('HH:mm') : '');
        }
    };
    dayjsClass.prototype.toTime = function (variant = 'short') {
        if (!this.isValid())
            return '';
        if (variant === 'short') {
            return this.format('HH:mm');
        }
        else if (variant === 'complete') {
            return this.format('HH:mm:ss');
        }
    };
    dayjsClass.prototype.toStringRelative = function (breakpoint, ...args) {
        if (!this.isValid())
            return '';
        if (breakpoint === 'today' && this.isToday()) {
            return this.fromNow(true);
        }
        else if (typeof breakpoint === 'number' && (this.isAfter(dayjs_1.default().add(breakpoint * -1, 'day'))
            ||
                this.isBefore(dayjs_1.default().add(breakpoint, 'day')))) {
            return this.fromNow(true);
        }
        else {
            return this.toStringDate(...args);
        }
    };
    dayjsClass.prototype.isToday = function () {
        if (!this.isValid())
            return false;
        return this.isSame(dayjs_1.default(), 'day');
    };
    dayjsClass.prototype.isTomorrow = function () {
        if (!this.isValid())
            return false;
        return this.isSame(dayjs_1.default().add(1, 'day'), 'day');
    };
    dayjsClass.prototype.isYesterday = function () {
        if (!this.isValid())
            return false;
        return this.isSame(dayjs_1.default().add(-1, 'day'), 'day');
    };
};
dayjs_1.default.extend(extended);
dayjs_1.default.extend(relativeTime_1.default);
dayjs_1.default.extend(quarterOfYear_1.default);
// import moment from 'moment';
// ( moment as any ).fn.getDay = function ( this: moment.Moment ): number
// {
//     return this.format( 'D' ).toInt();
// };
// ( moment as any ).fn.getMonth = function ( this: moment.Moment ): number
// {
//     return this.format( 'M' ).toInt();
// };
// ( moment as any ).fn.getYear = function ( this: moment.Moment ): number
// {
//     return this.format( 'YYYY' ).toInt();
// };
// ( moment as any ).fn.compare = function ( this: moment.Moment, hoy: moment.Moment ): boolean
// {
//     return hoy.getDay() === this.getDay() && hoy.getMonth() === this.getMonth() && hoy.getYear() === this.getYear();
// };
// ( moment as any ).fn.toSQL = function ( this: moment.Moment, hour: boolean = true ): string | null
// {
//     if ( !this.isValid() ) return null;
//     return this.format( 'YYYY-MM-DD' ) + ( hour ? ' ' + this.format( 'HH:mm:ss' ) : '' );
// };
// ( moment as any ).fn.isYesterday = function ( this: moment.Moment ): boolean
// {
//     let ayer = moment().add( -1, 'days' );
//     return this.compare( ayer );
// };
// ( moment as any ).fn.isToday = function ( this: moment.Moment ): boolean
// {
//     let hoy = moment();
//     return hoy.getDay() === this.getDay() && hoy.getMonth() === this.getMonth() && hoy.getYear() === this.getYear();
// };
// ( moment as any ).fn.mismoMes = function ( this: moment.Moment ): boolean
// {
//     let hoy = moment();
//     return hoy.getMonth() === this.getMonth() && hoy.getYear() === this.getYear();
// };
// ( moment as any ).fn.toDate = function ( this: moment.Moment, time: boolean = false, day: boolean = true ): string
// {
//     if ( !this.isValid() ) return '';
//     return ( day ? this.format( 'dddd, ' ) : '' ) + this.format( 'D' ) + " de " + this.format( 'MMMM' ) + ' de ' + this.format( 'YYYY' ) + ( time ? ' ' + this.toTime() : '' );
// };
// ( moment as any ).fn.toTime = function ( this: moment.Moment ): string
// {
//     if ( !this.isValid() ) return '';
//     return this.format( 'HH:mm' );
// };
// ( moment as any ).fn.toShortDate = function ( this: moment.Moment ): string
// {
//     if ( !this.isValid() ) return '';
//     return this.format( 'D/MM/YY HH:mm' );
// };
